<template>
    <div>
        <b-card class="sa-card" header="Indagine" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Data Primi Sintomi:</label>
                    <date-picker v-model="jsonData.dataPrimiSintomi" format="DD-MM-YYYY" value-type="timestamp" type="timestamp"></date-picker>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Febbre:</label>
                    <b-form-select v-model="jsonData.febbre" :options="siNoOptions" :value="''" value-field="value" text-field="text"></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Nausea:</label>
                    <b-form-select v-model="jsonData.nausea" :options="siNoOptions" :value="''" value-field="value" text-field="text"></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Astenia:</label>
                    <b-form-select v-model="jsonData.astenia" :options="siNoOptions" :value="''" value-field="value" text-field="text"></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Feci Alcoliche:</label>
                    <b-form-select v-model="jsonData.feciAlcoliche" :options="siNoOptions" :value="''" value-field="value" text-field="text"></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Ittero:</label>
                    <b-form-select v-model="jsonData.ittero" :options="siNoOptions" :value="''" value-field="value" text-field="text"></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Urine Ipercomiche:</label>
                    <b-form-select v-model="jsonData.urineIpercomiche" :options="siNoOptions" :value="''" value-field="value" text-field="text"></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Valori Transaminasi:</label>
                    <b-form-input v-model="jsonData.valoriTransaminasi"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Markers Presenti:</label>
                    <b-form-input v-model="jsonData.markersPrsenti"></b-form-input>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="Durante le 6 settimane prima dell'inizio dei sintomi" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Bevuto Acqua di pozzo:</label>
                    <b-form-select v-model="jsonData.acquaPozzo" :options="siNoOptions" :value="''" value-field="value" text-field="text"></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Consumanto Frutti di mare crudi/poco cotti:</label>
                    <b-form-select v-model="jsonData.fruttiMare" :options="siNoOptions" :value="''" value-field="value" text-field="text"></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Luogo Acquisto:</label>
                    <b-form-input v-model="jsonData.luogoAcquisto" :disabled="jsonData.fruttiMare !== 'SI'"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Data Consumo:</label>
                    <date-picker v-model="jsonData.dataConsumo" format="DD-MM-YYYY" value-type="timestamp" type="timestamp" :disabled="jsonData.fruttiMare !== 'SI'"></date-picker>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Frequantata Collettività:</label>
                    <b-form-select v-model="jsonData.frequentaCollettivita" :options="siNoOptions" :value="''" value-field="value" text-field="text"></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Luogo Collettività:</label>
                    <b-form-input v-model="jsonData.luogoCollettivita" :disabled="jsonData.frequentaCollettivita !== 'SI'"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Ultimo Giorno:</label>
                    <date-picker v-model="jsonData.dataUltimoContattoCollettivita" format="DD-MM-YYYY" value-type="timestamp" type="timestamp" :disabled="jsonData.frequentaCollettivita !== 'SI'"></date-picker>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Interventi Chirurgici:</label>
                    <b-form-select v-model="jsonData.interventiChirurgici" :options="siNoOptions" :value="''" value-field="value" text-field="text"></b-form-select>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                    <label class="sa-label-data">Dettaglio:</label>
                    <b-form-input v-model="jsonData.interventiChirurgiciDettaglio" :disabled="jsonData.interventiChirurgici !== 'SI'"></b-form-input>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="Dettaglio Medico" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Mmg/Pls:</label>
                    <b-form-input v-model="jsonData.mmgPdf"></b-form-input>
                </b-col>
                <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Telefono:</label>
                    <b-form-input v-model="jsonData.telMmgPdf"></b-form-input>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="Contatti/Conviventi" header-tag="header" footer-tag="footer" title="">
            <b-table sticky-header ref="tblViaggi" stacked="xl" striped hover itemscope :items="jsonData.listaContattiConviventi" :fields="fieldsContatti" :current-page="currentPage" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table">
                <template #cell(index)="jsonData">
                    {{ jsonData.index + 1 }}
                </template>
                <template #cell(cognome)="item">
                    <b-form-input v-model="item.item.cognome"></b-form-input>
                </template>
                <template #cell(nome)="item">
                    <b-form-input v-model="item.item.nome"></b-form-input>
                </template>
                <template #cell(eta)="item">
                    <b-form-input v-model="item.item.eta"></b-form-input>
                </template>
                <template #cell(professione)="item">
                    <!-- <b-form-select v-model="item.item.professione" :options="professioniOptions" :value="''" value-field="value" text-field="text"></b-form-select> -->
                    <b-form-input v-model="item.item.professione"></b-form-input>
                </template>
                <template #cell(mmgPls)="item">
                    <b-form-input v-model="item.item.mmgPls"></b-form-input>
                </template>
                <template #cell(telefono)="item">
                    <b-form-input v-model="item.item.telefono"></b-form-input>
                </template>
                <template #cell(statoImmunitario)="item">
                    <b-form-input v-model="item.item.statoImmunitario"></b-form-input>
                </template>
                <template #cell(actions)="row">
                    <b-button v-if="row.index == jsonData.listaContattiConviventi.length - 1" size="sm" variant="btn btn-outline-success waves-effect waves-light width-sm no-text" @click="onAddContatto(jsonData.listaContattiConviventi, row.item)">
                        <b-icon icon="plus"></b-icon>
                    </b-button>
                    <b-button v-if="row.index !== jsonData.listaContattiConviventi.length - 1" size="sm" variant="btn btn-outline-danger waves-effect waves-light width-sm no-text" @click="onDelete(jsonData.listaContattiConviventi, row)">
                        <b-icon icon="trash"></b-icon>
                    </b-button>
                </template>
            </b-table>
        </b-card>
        <b-card class="sa-card" header="Altre Considerazioni" header-tag="header" footer-tag="footer" title="">
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <b-form-textarea v-model="jsonData.altreConsiderazioni" rows="6" no-resize></b-form-textarea>
                </b-col>
            </b-row>
        </b-card>
        <b-card class="sa-card" header="Dati Notifica" header-tag="header" footer-tag="footer" title="">
            <indagine-epidemiologica-dati-notifica-component :jsonData="jsonData" :isEdit="true" @update="onUpdateJsonData"></indagine-epidemiologica-dati-notifica-component>
        </b-card>
    </div>
</template>
<script>
import axios from "axios";
import UtilityMixin from "../../../utility/UtilityMixin";
import DatePicker from "vue2-datepicker";
import Vue from "vue";
import IndagineEpidemiologicaDatiNotificaComponent from "./IndagineEpidemiologicaDatiNotificaComponent.vue";
export default {
    props: {
        utente: {
            type: Object,
            default: function () {
                return null;
            },
        },
    },
    components: { IndagineEpidemiologicaDatiNotificaComponent, DatePicker }, //
    mixins: [UtilityMixin],
    data() {
        return {
            pathResource: "/malattieinfettiveieepatiteacuta",
            pathResourceMalattiaInfettivaSegnalazione: "/malattieinfettivesegnalazioni",
            linkback: null,
            currentPage: 1,
            perPage: 100,
            showModalLoading: false,
            linkNazioni: "/nazioni",
            pathResourceComuni: "/comuni",
            pathResourceProvince: "/province",
            // linkNazioni: "/nazioni",
            disableSintomi: true,
            jsonData: {
                id: "",
                idAnagrafica: "",
                dataPrimiSintomi: null,
                febbre: "",
                nausea: "",
                astenia: "",
                feciAlcoliche: "",
                ittero: "",
                urineIpercomiche: "",
                valoriTransaminasi: "",
                markersPrsenti: "",
                sanitarioNotificante: "",
                sanitarioNotificanteContatto: "",
                dataNotifica: null,
                acquaPozzo: "",
                fruttiMare: "",
                luogoAcquisto: "",
                dataConsumo: null,
                frequentaCollettivita: "",
                luogoCollettivita: "",
                dataUltimoContattoCollettivita: null,
                interventiChirurgici: "",
                interventiChirurgiciDettaglio: "",
                mmgPdf: "",
                telMmgPdf: "",
                altreConsiderazioni: "",
                listaContattiConviventi: [],
            },
            siNoOptions: [
                { value: "", text: "-Seleziona Valore-" },
                { value: "SI", text: "SI" },
                { value: "NO", text: "NO" },
            ],
            fieldsContatti: [
                {
                    label: "",
                    key: "index",
                    sortable: false,
                    thStyle: "width: 2rem",
                },
                {
                    label: "Cognome",
                    key: "cognome",
                    thStyle: "width: 20rem",
                    sortable: false,
                },
                {
                    label: "Nome",
                    key: "nome",
                    thStyle: "width: 20rem",
                    sortable: false,
                },
                {
                    label: "Età",
                    key: "eta",
                    thStyle: "width: 10rem",
                    sortable: false,
                },
                {
                    label: "Professione",
                    key: "professione",
                    // thStyle: "width: 5rem",
                    sortable: false,
                },
                {
                    label: "Mmg/pls",
                    key: "mmgPls",
                    // thStyle: "width: 5rem",
                    sortable: false,
                },
                {
                    label: "Stato Immunitario",
                    key: "statoImmunitario",
                    thStyle: "width: 20rem",
                    sortable: false,
                },
                {
                    label: "",
                    key: "actions",
                    sortable: false,
                    thStyle: "width: 4rem",
                },
            ],
        };
    },
    computed: {
        idPaziente() {
            return this.$route.query.idPaziente;
        },
        linkPatient() {
            return UtilityMixin.methods.getLinkPatient(this.utente, this.idPaziente);
        },
    },
    mounted() {
        let me = this;
        me.id = this.$route.params.id;
        me.jsonData.idAnagrafica = me.idPaziente;
        me.jsonData.id = me.id;
        me.loadMalattiaInfettivaSegnalazione();
        // me.loadNazioni();
        me.loadData();
    },
    watch: {
        jsonData: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    methods: {
        loadData() {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResource + "/";
            me.showModalLoading = true;
            axios
                .get(link + me.id)
                .then((response) => {
                    me.jsonData = response.data.data;
                    me.jsonData.listaContattiConviventi.push({ cognome: "", nome: "", eta: "", professione: "", mmgPls: "", statoImmunitario: "" });
                    me.showModalLoading = false;
                })
                .catch(() => {
                    me.jsonData.listaContattiConviventi.push({ cognome: "", nome: "", eta: "", professione: "", mmgPls: "", statoImmunitario: "" });
                    me.setDatiMedico();
                    me.showModalLoading = false;
                });
        },
        loadMalattiaInfettivaSegnalazione() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceMalattiaInfettivaSegnalazione + "/";
            axios
                .get(link + me.id)
                .then((response) => {
                    me.setDatiMalattia(response.data.data);
                    me.showModalLoading = false;
                })
                .catch(() => {
                    me.showModalLoading = false;
                });
        },
        setDatiMedico() {
            let me = this;
            me.jsonData.sanitarioNotificante = Vue.prototype.user.firstname + " " + Vue.prototype.user.lastname;
        },
        setDatiMalattia(data) {
            let me = this;
            me.jsonData.id = data.id;
        },
        onUpdateJsonData(data) {
            let me = this;
            me.jsonData = data;
        },
        loadNazioni() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + me.linkNazioni;
            axios.get(link).then((response) => {
                me.nazioniOptions = response.data.data;
            });
        },
        onAddContatto(array, value) {
            if (value.cognome !== "" && value.nome !== "") {
                array.push({ cognome: "", nome: "", eta: "", professione: "", mmgPls: "", statoImmunitario: "" });
            } else {
                this.$bvModal
                    .msgBoxOk("Campi OBBLIGATORI!", {
                        title: "ATTENZIONE",
                        size: "sm",
                        okVariant: "outline-danger",
                        headerClass: "sa-msg-header-danger",
                        footerClass: "p-2 border-top-0",
                        centered: true,
                    })
                    .then((value) => {
                        console.log(value);
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        },
        onDelete(array, row) {
            if (row.index != array.length) {
                this.$bvModal
                    .msgBoxConfirm("Sicuro di voler procedere alla cancellazione?", {
                        title: "Titolo",
                        buttonSize: "sm",
                        okVariant: "secondary",
                        cancelVariant: "danger",
                        okTitle: "SI",
                        cancelTitle: "NO",
                        footerClass: "p-2",
                        hideHeaderClose: false,
                        centered: true,
                    })
                    .then((value) => {
                        if (value) {
                            array.splice(row.index, 1);
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
        },
    },
};
</script>
